
<div class="row ss-top-menu">
  <div class="col-sm-12">
    <span class="ss-text-light rk-activeLink addCursor" routerLink="/">Dashboard  </span>
    <span class="ml-5 mr-2" id="offlineText">I'm Offline</span>
    <input type="range" min="1" max="2" value="1" class="slider" id="statusSwitch" (change)="onchange($event.target)" [(ngModel)]="agentStatus">
    <span class="ml-2 notactivestatusText"  id="onlineText">I'm Online</span>
    <button class="btn btn-outline-secondary pull-right btn-lg bt-boq" type="button" data-toggle="modal" data-target="#addNewLeadModal" (click)="changeShowStatus('offline')">Add Lead</button>
  </div>
</div>
<div class="row marginTop pt-3 CsagentDashboardContainer" *ngIf="!showStatus && userAgentDetails">
  <div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  <div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
  </div>

	<div class="col-lg-12 mt-2 mb-4">
		<h5 class="titleText">Leads count by Status</h5>
	</div>
  <div class="col-sm-3 my-3">
    <div class="card py-2 px-2">
      <div class="mt-3 mb-4 ml-2 mr-1">
        <img src="assets/v3/img/claim.svg" class="cardHeadingIcon">
          <span class="statusCardHeadingColor ml-4">Claimed</span>
        </div>
        <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor">{{userAgentDetails.leads_claimed}}</h1>
        <div class="ml-3 mr-2 statusCardContent">
          <p>Count of all the leads which have been claimed by you.</p>
        </div>
    </div>
  </div>
  <div class="col-sm-3 my-3">
    <div class="card py-2 px-2">
      <div class="mt-3 mb-4 ml-2 mr-1">
        <img src="assets/v3/img/qualified.svg" class="cardHeadingIcon">
          <span class="statusCardHeadingColor ml-4">Qualified</span>
        </div>
        <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor">{{userAgentDetails.leads_qualified}}</h1>
        <div class="ml-3 mr-2 statusCardContent">
          <p>Count of all the leads which have been qualified.</p>
        </div>
    </div>
  </div>
</div>

<div class="row marginTop" *ngIf="showStatus">
  <div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  <div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
  </div>
  <div class="col-12 px-2 mt-2 mb-5 leadDetailsContainer">

    <div class="card">
      <div class="headingBlock">
        <h6 class=" mt-2 mx-1">Lead Details <span class="pull-right">Timer - <span id="timer1">1:00</span> </span></h6>
      </div>
      <div class="row mx-1 text-center" *ngIf="activeLeadDataForAgent==undefined || activeLeadDataForAgent==null ">
        No leads are available .
      </div>
      <div class="row mx-1"  style="padding: 25px 10px 0px 0px;" *ngIf="activeLeadDataForAgent">
        <div class="col-md-4 mb-4">
          <label>Lead Name</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.name}}"  readonly>
        </div>
        <div class="col-md-4 mb-4">
          <label>Lead Email</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.email}}"  readonly>
        </div>
        <div class="col-md-4 mb-4">
          <label>Lead Contact Number</label>
          <input type="text" class="form-control" placeholder="{{ activeLeadDataForAgent.contact}}" readonly>
          
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Date Of Acquisition</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.timestamp | date:'dd  MMM, yyyy'}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Time Of Acquisition</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.timestamp | date:'h:mma'}} ({{activeLeadDataForAgent.hours_ago }})" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Pincode*</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.pincode}}" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Source</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_source | replaceChar}}" readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Type</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_type | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Lead Campaign</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_campaign | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2">
          <label>Status</label>
          <input type="text" class="form-control"  placeholder="{{activeLeadDataForAgent.lead_status | replaceChar}}"  readonly>
        </div>
        <div class="col-md-4 mb-4 mt-2" *ngIf="activeLeadDataForAgent.lead_status=='follow_up'">
          <label>Follow up time</label>
          <p class="labelColor">{{activeLeadDataForAgent.follow_up_time | date:'dd/MM/yyyy @ h:mma'}}</p>
        </div>
        <div class="col-md-12 mb-4 mt-2" *ngIf="activeLeadDataForAgent.lead_status=='follow_up'">
          <label>Follow Up Remark</label>
          <p style="" class="labelColor">{{activeLeadDataForAgent.remark}}</p>
        </div>
        <div class="col-md-12 mb-4">
          <button type="button" class="rk-interalBtnColor addCursor pull-right" style="width: 115px;" (click)="stopTimerAfterClaimLead(activeLeadDataForAgent.id); startTimer1();getUserQuestionnaireDetails(activeLeadDataForAgent.id,activeLeadDataForAgent.lead_status)">Claim Lead</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add lead modal -->
<div class="modal fade customModal" id="addNewLeadModal" tabindex="-1" role="dialog" aria-labelledby="addNewLeadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <form (ngSubmit)="addLeadFormSubmit(addLeadForm.value); " [formGroup]="addLeadForm" class="form-horizontal" enctype="multipart/form-data" id="addLeadForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel"> Lead Details</h5>
        </div>
        <div class="modal-body">
          <div class="row mx-2">
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Name </label>
                <input type="text" class="form-control" name="name" placeholder="Enter Lead Name" formControlName="name">
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Email</label>
                <input type="text" class="form-control" name="email" placeholder="Enter Lead Email" formControlName="email">
                <div *ngIf="addLeadForm.controls['email'].errors && !addLeadForm.controls['email'].pristine" class="text-danger">

                  <div [hidden]="addLeadForm.controls['email'].valid">Enter valid email.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Lead Contact <span>*</span></label>
                <input type="number" class="form-control" name="contact" placeholder="Enter Lead Contact" formControlName="contact" required min="0" (keydown)="numberCheck($event)">
                <div *ngIf="addLeadForm.controls['contact'].errors && !addLeadForm.controls['contact'].pristine" class="text-danger">
                  <div [hidden]="!addLeadForm.controls['contact'].errors.required">Contact is required.</div>
                </div>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 mb-2">
              <div class="form-group">
                <label class="text-left">Pincode</label>
                <input type="number" class="form-control" name="pincode" placeholder="Enter Lead Pincode" formControlName="pincode" min="0" (keydown)="numberCheck($event)">
              </div>
            </div>

            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Type <span>*</span></label>
                <select formControlName="lead_type_id" class="form-control capitalize" (change)="showLeadStatusDropdown($event.target.value); onChangeOfLeadType($event.target.value)">
                	<option value="" disabled>Select</option>
                  <option value="{{type.id}}" *ngFor="let type of lead_types">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Source <span>*</span></label>
                <select formControlName="lead_source_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{src.id}}" *ngFor="let src of lead_sources">{{src.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6">
              <div class="form-group">
                <label class="text-left">Select Lead Campaign </label>
                <select formControlName="lead_campaign_id" class="form-control capitalize">
                  <option value="" disabled>Select</option>
                  <option value="{{camp.id}}" *ngFor="let camp of lead_campaigns">{{camp.name | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6 d-none" id="addLeadStatusDropdown">
              <div class="form-group">
                <label class="text-left">Select Lead Status </label>
                <select formControlName="lead_status" class="form-control capitalize" (change)="setLeadStatus1($event.target.value)">
                  <option value="" disabled>Select</option>
                  <option value="qualified">Qualified</option>
                  <option value="follow_up">Follow Up</option>
                  <option value="lost">Lost</option>
                  <option value="not_contactable">Not Contactable</option>
                </select>
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Instagram Id </label>
                <input type="text" formControlName="instagram_handle" name="" class="form-control">
              </div>
            </div>
            <div class="col-sm-10 col-md-6" *ngIf="addLeadForm.controls['lead_type_name'].value=='designer'">
              <div class="form-group">
                <label class="text-left">Upload CV </label>
                <input type="file" name="" class="form-control" (change)="uploadCV($event)" name="attachment_file">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormdatetime" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Time</label>
                <input type="datetime-local" formControlName="follow_up_time" name="" class="form-control">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormRemark" style="display: none;">
              <div class="form-group">
                <label class="text-left">Follow up Remark</label>
                <input type="text" formControlName="remark" name="" class="form-control">
              </div>
            </div>
            <div class="col-md-6" id="addleadFormlostReason" style="display: none;">
              <div class="form-group">
                <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                <div class="">
                  <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange($event.target.value)">
                    <option value="" disabled>Select Reason</option>
                    <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                  </select>
                  </div>
              </div>
            </div>
            <div class="col-md-6"  id="addleadFormlostremark" style="display: none;">
              <div  class="form-group">
                <label >Remarks</label>
                <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
              </div>
            </div>
            <div class="col-sm-12 mt-3 text-right">
              <div class="mt-3">
              <button type="submit" [disabled]="!addLeadForm.valid" class="rk-interalBtnColor addCursor">Add</button>
              <button class="cancle ml-3 addCursor rk-btnCancel" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="addleadquestionnaire" (ngSubmit)="addLeadQuestionnaire(addleadquestionnaire.value);" id="addleadquestionnaireForm" style="display: none;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title modalTitle" id="exampleModalLabel">Lead Questionnaire</h5>
        </div>
        <div class="modal-body addleadQuestionnaireModal">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="row mx-1 mb-4 mt-2 row1">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label class="customLabel">Project Name</label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="project_name">
                  </div>
                </div>
                <div class="col-sm-10 col-md-3">
                  <label class="customLabel">Call Back Day <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <input type="date" name="" formControlName="call_back_day" class="form-control">
                  </div>
                </div>

                <div class="col-sm-6 col-md-3">
                  <label class="customLabel">Call Back Time </label>
                  <div class="form-check">
                    <select formControlName="call_back_time" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label class="customLabel">Location <span class="hideAsteriskIcon text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="location">
                  </div>
                </div>
              </div>
              <div class="row row2 mx-1">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label class="customLabel">Society/Building Name<span class="hideAsteriskIcon text-danger">*</span> </label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="society">
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label>Pincode <span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Please Enter Pincode" formControlName="pincode">
                  </div>
                </div>
                <div class="col-sm-10 col-md-12 mt-3">
                  <label class="customLabel">City <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 capitalize" *ngFor="let city of citiesForQuestionnaire;">
                      <input class="form-check-input capitalize" type="radio" value="{{city.name}}" formControlName="city" (change)="onchangeCity1(city.name)">
                      {{city.name | replaceChar}}
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Other" formControlName="city" (change)="onchangeCity1('Other')">
                      Other <input type="text" name="city_others" class="ml-2" class="form-control d-none" style="margin-top: -10px; width: 72%;display: inline-block;border-color: red;" [(ngModel)]="city_others" [ngModelOptions]="{standalone: true}" id="cityOthersInput1">
                    </label>
                  </div>
                </div>


                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Project Type <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label mr-4 lableSize labelColor mb-2">
                      <input class="form-check-input" type="radio" value="Residential" formControlName="project_type">
                      Residential
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Offices" formControlName="project_type">
                      Offices
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Type of Accommodation <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mr-4" *ngFor="let at of accommodation_type">
                      <input class="form-check-input" type="radio" value="{{at}}" formControlName="accomodation_type">
                      {{at}}
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Type of Home <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="New (No one has ever stayed in that home)" formControlName="home_type">
                      New (No one has ever stayed in that home)
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Old (Currently staying in the house)" formControlName="home_type">
                      Old (Currently staying in the house)
                    </label>
                  </div>
                </div>
                <div class="col-sm-10 col-md-12 mt-3">
                  <label class="customLabel">Possession status <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Possession Taken" formControlName="possession_status" (click)="possesionStatusSelected('Possession Taken','addleadQuestionnaire')">
                      Possession Taken
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Awaiting Possession" formControlName="possession_status" (click)="possesionStatusSelected('Awaiting Possession','addleadQuestionnaire')">
                      Awaiting Possession (If Yes, please fill the date of possession below on "other")
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-5 mt-3" id="possesionadd_date" style="display:none;">
                  <label class="customLabel">Estimated month of Possession <span class="hideAsteriskIcon text-danger">*</span></label>
                  <select formControlName="possession_status_date" class="form-control">
                    <option value="" disabled>Choose</option>
                    <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Scope of work <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngFor="let sw of scopeOfwork">
                      <!-- <input type="checkbox" class="form-check-input" value="{{sw}}" (change)="onCheckChange($event,'scope_of_work')"> -->
                      <input type="radio" class="form-check-input" value="{{sw}}" formControlName="scope_of_work">
                      {{sw}}
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Do you have a home loan against the property? <span class="hideAsteriskIcon text-danger">*</span></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Yes" formControlName="have_homeloan">
                      Yes
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="No" formControlName="have_homeloan">
                      No
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Doesn't want to disclose" formControlName="have_homeloan">
                      Doesn't want to disclose
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 mt-3">
                  <label class="customLabel">Do you have a floor plan? </label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="Yes" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('yes','floorplanQuestionnaire')">
                      Yes
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4">
                      <input class="form-check-input" type="radio" value="No" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('no','floorplanQuestionnaire')">
                      No
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 mt-3" id="floorplanQuestionnaire" style="display: none;">
                  <label class="customLabel">Upload Floorplan</label>
                  <div class="form-check">
                    <input class="form-control" type="file" (change)="onQuestionnaireFloorplanChange($event)" name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel" [ngModelOptions]="{standalone: true}">
                  </div>
                  <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in proper image format).</p>
                  <p class="col-sm-10">Note* - only image files are allowed.  </p>
                </div>

                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Home Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                    <select formControlName="home_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 30 Lacs">Less than 30 Lacs</option>
                      <option value="30 - 50 Lacs">30 - 50 Lacs</option>
                      <option value="50 - 70 Lacs">50 - 70 Lacs</option>
                      <option value="70 - 99 Lacs">70 - 99 Lacs</option>
                      <option value="1 - 1.25 Cr">1 - 1.25 Cr</option>
                      <option value="1.26 - 1.75 Cr">1.26 - 1.75 Cr</option>
                      <option value="1.76 - 2.50 Cr">1.76 - 2.50 Cr</option>
                      <option value="Above 2.50 Cr">Above 2.50 Cr</option>
                      <option value="Not Available">Not Available </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Budget Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                    <select formControlName="budget_value" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 1.5 Lac">Less than 1.5 Lac</option>
                      <option value="1.5 - 3 Lacs">1.5 - 3 Lacs</option>
                      <option value="3 - 5 Lacs">3 - 5 Lacs</option>
                      <option value="5 - 8 Lacs">5 - 8 Lacs</option>
                      <option value="8 - 12 Lacs">8 - 12 Lacs</option>
                      <option value="Above 12 Lacs">Above 12 Lacs</option>
                      <option value="Not Disclosed">Not Disclosed</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Lead Generator</label>
                    <select formControlName="lead_generator" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Akshay Pawar">Akshay Pawar</option>
                      <option value="Azhar Khan">Azhar Khan</option>
                      <option value="Rohit Dalvi">Rohit Dalvi</option>
                      <option value="Roshni Malik">Roshni Malik</option>
                      <option value="Roshan">Roshan</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-3">
                  <div class="form-group">
                    <label class="customLabel">Lead Source</label>
                    <select formControlName="lead_source" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="Facebook Campaign">Facebook Campaign</option>
                      <option value="Inbound Call">Inbound Call</option>
                      <option value="Housing Finance">Housing Finance</option>
                      <option value="Facebook Direct">Facebook Direct</option>
                      <option value="Get a callback from us">Get a callback from us</option>
                      <option value="Broker">Broker</option>
                      <option value="Referral">Referral</option>
                      <option value="Dealer">Dealer</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4">
                  <label class="customLabel">Additional Comments</label>
                  <div class="form-check">
                    <textarea rows="2" class="form-control" formControlName="additional_comments"></textarea>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4">
                  <label class="customLabel">Change Status <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <select class="form-control" formControlName="lead_status" (change)="setLeadStatus2($event.target.value)">
                      <option value="" disabled>Select Status</option>
                      <option value="qualified">Qualified</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4" id="addleadQuestFollowuptime" style="display: none">
                  <label class="customLabel">Followup Time <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <input class="form-control" type="datetime-local" formControlName="follow_up_time">
                  </div>
                </div>
                <div class="col-sm-10 col-md-5 mt-4" id="addleadQuestRemark" style="display: none">
                  <label class="customLabel">Followup remark <span class="text-danger">*</span></label>
                  <div class="form-check">
                    <input class="form-control" type="text" formControlName="remark">
                  </div>
                </div>
                <div class="col-md-6" id="addleadQuestLostReason" style="display: none;">
                  <div class="form-group">
                    <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                    <div class="">
                      <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange1($event.target.value)">
                        <option value="" disabled>Select Reason</option>
                        <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                      </select>
                      </div>
                  </div>
                </div>
                <div class="col-sm-10 col-md-5" id="addleadFormquestremark" style="display: none">
                  <label class="customLabel">Remarks</label>
                  <div class="form-check">
                    <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
                  </div>
                </div>
                <!-- <pre>{{addleadquestionnaire.value | json }}</pre> -->
                <div class="col-sm-12 col-md-12 text-right">
                    <button type="submit" class="mt-4 rk-interalBtnColor addCursor " [disabled]="!addleadquestionnaire.valid || (addleadquestionnaire.valid && addleadquestionnaire.controls['city'].value=='Other' && (city_others=='' ||city_others==undefined))">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>


<!-- lead details modal -->
<div class="modal fade" id="leadDetailsModal" tabindex="-1" role="dialog" aria-labelledby="leadDetailsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title modalTitle col-md-5" id="exampleModalLabel">Lead Details</div>
        <div class="modalTitle col-md-6 text-right" style="background:transparent;">Time left : <span id="timer">20:00</span></div>
        <button type="button" class="close close1">
          <img class="close" (click)="closeModal();"  src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
        </button>
      </div>

      <div class="modal-body leadView" *ngIf="leadDetails">
        <div class="row addClass">
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Name <span class="text-danger hideAsteriskIcon">*</span></label>
              <input type="text" class="form-control" placeholder="{{leadDetails.name}}" [(ngModel)]="leadName">
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Contact</label>
              <p class="addCursor"><span (click)="callLead(leadDetails.id)" class="callText">Call To {{leadDetails.contact}} - </span><i class="fa fa-phone callIcon" (click)="callLead(leadDetails.id)"></i></p>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Date Of Acquisition (dd-mm-yyyy)</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.created_at | date:'dd  MMM, yyyy , h:mm a'}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Source</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_source}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Campaign</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_campaign}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Role</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_type}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Status</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lead_status | replaceChar | ucwords}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_status=='follow_up'">
            <div class="form-group" >
              <label>Follow up time</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.follow_up_time}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_status=='lost'">
             <div class="form-group" >
              <label>Remarks</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.lost_remark}}" readonly>
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Lead Email </label>
              <input type="text" class="form-control" value="{{leadDetails.email}}" [(ngModel)]="leadEmail">
            </div>
          </div>
          <div class="col-sm-10 col-md-6">
            <div class="form-group">
              <label>Pincode <span class="text-danger"></span></label>
              <input type="text" class="form-control" placeholder="{{leadDetails.pincode}}" [(ngModel)]="leadPincode">
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_type=='designer' ">
            <div class="form-group">
              <label>Instagram Id</label>
              <input type="text" class="form-control" placeholder="{{leadDetails.instagram_handle}}" [(ngModel)]="leadInstagramhandle">
            </div>
          </div>
          <div class="col-sm-10 col-md-6" *ngIf="leadDetails.lead_type=='designer' ">
            <div class="form-group">
              <label>Upload CV</label>
              <input type="file" class="form-control" (change)="uploadCV($event)" name="attachment_file">
              <a href="https://{{lead_designerCV}}" *ngIf="lead_designerCV" onerror="this.src='./assets/img/no_image.svg'" target="_blank">View CV</a>
            </div>
          </div>

          <div class="col-md-12">
            <div class="">
              <form [formGroup]="leadquestionnaire"  *ngIf=" leadDetails && leadDetails.lead_type =='customer'">
                <!-- <pre>{{ leadquestionnaire.value | json}}</pre> -->
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="customLabel">Project Name</label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="project_name">
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Society/Building Name <span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="society">
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Location <span class="text-danger hideAsteriskIcon">*</span></label>
                    <input type="text" class="form-control" placeholder="Your answer" formControlName="location">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">City <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 capitalize" *ngFor="let city1 of citiesForQuestionnaire;">
                        <input class="form-check-input" type="radio" value="{{city1.name}}" formControlName="city" (change)="onchangeCity2(city1.name)">
                        {{city1.name | replaceChar}}
                      </label>

                      <label class="form-check-label labelColor lableSize mr-2">
                        <input class="form-check-input" type="radio" value="Other" formControlName="city" (change)="onchangeCity2('Other')">
                        Other: <input type="text" name="city_others" class="ml-1 d-none" [(ngModel)]="city_others" style="margin-top: -10px; width: 72%;display: inline-block;" [ngModelOptions]="{standalone: true}" id="cityOthersInput2">
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Project Type <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2">
                        <input class="form-check-input" type="radio" value="Residential" formControlName="project_type">
                        Residential
                      </label>
                      <label class="form-check-label labelColor lableSize mr-2">
                        <input class="form-check-input" type="radio" value="Offices" formControlName="project_type">
                        Offices
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                      <label class="customLabel">Type of Accommodation <span class="text-danger hideAsteriskIcon">*</span></label>
                      <div class="form-check">
                        <label class="form-check-label labelColor lableSize mr-2 mb-2" *ngFor="let at of accommodation_type">
                          <input class="form-check-input" type="radio" value="{{at}}" formControlName="accomodation_type" >
                          {{at}}
                        </label>
                      </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Type of Home <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="New (No one has ever stayed in that home)" formControlName="home_type">
                        New (No one has ever stayed in that home)
                      </label>
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="Old (Currently staying in the house)" formControlName="home_type">
                        Old (Currently staying in the house)
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Scope of work <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2" *ngFor="let sw of scopeOfwork">
                        <!-- <input type="checkbox" class="form-check-input"  (change)="onCheckChange($event,'scope_of_work')" value="{{sw}}" [checked]="(userQuestionnaireDetails && userQuestionnaireDetails[0] && userQuestionnaireDetails[0]['scope_of_work']!=null && userQuestionnaireDetails[0]['scope_of_work'].indexOf(sw) >=0) || (userQuestionnaireDetails && userQuestionnaireDetails['scope_of_work']!=null && userQuestionnaireDetails['scope_of_work'].indexOf(sw) >=0)"> -->
                        <input type="radio" class="form-check-input" formControlName="scope_of_work" value="{{sw}}">
                        {{sw}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Possession status <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="Possession Taken" formControlName="possession_status" (click)="possesionStatusSelected('Possession Taken','leadQuestionnaire')">
                        Possession Taken
                      </label>
                      <label class="form-check-label labelColor lableSize">
                        <input class="form-check-input" type="radio" value="Awaiting Possession" formControlName="possession_status" (click)="possesionStatusSelected('Awaiting Possession','leadQuestionnaire')">
                        Awaiting Possession (If Yes, please fill the date of possession below on "other")
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6" id="possesiondate" >
                    <label class="customLabel">Estimated month of Possession <span class="text-danger hideAsteriskIcon">*</span></label>
                    <select formControlName="possession_status_date" class="form-control">
                      <option value="" disabled>Choose</option>
                      <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                      <label class="customLabel">Home Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                      <select formControlName="home_value" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="Less than 30 Lacs">Less than 30 Lacs</option>
                        <option value="30 - 50 Lacs">30 - 50 Lacs</option>
                        <option value="50 - 70 Lacs">50 - 70 Lacs</option>
                        <option value="70 - 99 Lacs">70 - 99 Lacs</option>
                        <option value="1 - 1.25 Cr">1 - 1.25 Cr</option>
                        <option value="1.26 - 1.75 Cr">1.26 - 1.75 Cr</option>
                        <option value="1.76 - 2.50 Cr">1.76 - 2.50 Cr</option>
                        <option value="Above 2.50 Cr">Above 2.50 Cr</option>
                        <option value="Not Available">Not Available </option>
                      </select>
                  </div>
                  <div class="col-sm-10 col-md-6 form-group">
                      <label class="customLabel">Budget Value(In Rs Lacs)<span class="hideAsteriskIcon text-danger">*</span></label>
                      <select formControlName="budget_value" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="Less than 1.5 Lac">Less than 1.5 Lac</option>
                        <option value="1.5 - 3 Lacs">1.5 - 3 Lacs</option>
                        <option value="3 - 5 Lacs">3 - 5 Lacs</option>
                        <option value="5 - 8 Lacs">5 - 8 Lacs</option>
                        <option value="8 - 12 Lacs">8 - 12 Lacs</option>
                        <option value="Above 12 Lacs">Above 12 Lacs</option>
                        <option value="Not Disclosed">Not Disclosed</option>
                      </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Do you have a home loan against the property? <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="have_homeloan">
                        Yes
                      </label>
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="No" formControlName="have_homeloan">
                        No
                      </label>
                      <label class="form-check-label labelColor lableSize mr-2 mb-2">
                        <input class="form-check-input" type="radio" value="Doesn't want to disclose" formControlName="have_homeloan">
                        Doesn't want to disclose
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="customLabel">Call Back Day <span class="text-danger hideAsteriskIcon">*</span></label>
                    <div class="form-check">
                      <input type="date" formControlName="call_back_day" class="form-control">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Call Back Time </label>
                    <div class="form-check">
                      <select formControlName="call_back_time" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="customLabel">Do you have a floor plan? </label>
                    <div class="form-check">
                      <label class="form-check-label labelColor lableSize">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('yes','floorplanQuestionnaire1')">
                        Yes
                      </label>
                      <label class="form-check-label labelColor lableSize">
                        <input class="form-check-input" type="radio" value="No" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('no','floorplanQuestionnaire1')">
                        No
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-6" id="floorplanQuestionnaire1" style="display: none;">
                    <label class="customLabel">Upload Floorplan</label>
                    <div class="form-check">
                      <input class="form-control" type="file" (change)="onQuestionnaireFloorplanChange($event)" name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel" [ngModelOptions]="{standalone: true}">
                    </div>
                    <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in proper image format).</p>
                    <p class="col-sm-10">Note* - only image files are allowed.  </p>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label class="customLabel">Lead Generator</label>
                    <div class="form-check">
                      <select formControlName="lead_generator" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="Akshay Pawar">Akshay Pawar</option>
                        <option value="Azhar Khan">Azhar Khan</option>
                        <option value="Rohit Dalvi">Rohit Dalvi</option>
                        <option value="Roshni Malik">Roshni Malik</option>
                        <option value="Roshan">Roshan</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="customLabel">Lead Source</label>
                    <div class="form-check">
                      <select formControlName="lead_source" class="form-control">
                        <option value="" disabled>Choose</option>
                        <option value="Facebook Campaign">Facebook Campaign</option>
                        <option value="Inbound Call">Inbound Call</option>
                        <option value="Housing Finance">Housing Finance</option>
                        <option value="Facebook Direct">Facebook Direct</option>
                        <option value="Get a callback from us">Get a callback from us</option>
                        <option value="Broker">Broker</option>
                        <option value="Referral">Referral</option>
                        <option value="Dealer">Dealer</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label class="customLabel">Additional Comments</label>
                    <div class="form-check">
                      <textarea rows="2" class="form-control" formControlName="additional_comments"></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="leadStatusUpdateForm">
                <div class="row">
                  <div class="col-6">
                    <label>Change Status</label>
                    <select class="form-control" (change)="setLeadStatus($event.target.value)" formControlName="lead_status" id="chnagestatusDropDown">
                      <option value="" disabled>Select Status</option>
                      <option value="qualified">Qualified</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option>
                    </select>
                  </div>
                  <div class="col-6" id="datetime" style="display: none;">
                    <div class="form-group">
                      <label>Follow up time</label>
                      <input class="form-control" type="datetime-local" formControlName="follow_up_time">
                      <!-- <input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" placeholder="Enter Date & Time" formControlName="follow_up_time" class="form-control">
                      <owl-date-time #dt3 ></owl-date-time> -->
                    </div>
                  </div>
                  <div class="col-6" id="remarkChange" style="display: none;">
                    <div class="form-group">
                      <label>Follow up Remark</label>
                      <input class="form-control" type="text" formControlName="remark">
                    </div>
                  </div>
                  <div class="col-md-6" id="lostreason" style="display: none;">
                    <div class="form-group">
                      <label for="example-text-input" class="text-left">Reason for Lost <span class="text-danger">*</span></label>
                      <div class="">
                        <select class="form-control" id="lost_reason" formControlName="lost_reason" (change)="reasonForLostDropdownChange2($event.target.value)">
                          <option value="" disabled>Select Reason</option>
                          <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                        </select>
                        </div>
                    </div>
                  </div>
                  <div class="col-6" style="display: none;" id="lostremark">
                    <div class="form-group">
                      <label >Remarks</label>
                      <textarea class="form-control" rows="2" formControlName="lost_remark"></textarea>
                    </div>
                  </div>
                </div>
              </form><br>
              <div class="text-right">
                <button class="rk-interalBtnColor addCursor" (click)="updateStatus(leadStatusUpdateForm.value,leadquestionnaire.value,leadDetails.id);" id="updateStatusBtn" [disabled]= "!leadquestionnaire.valid || (leadquestionnaire.valid && leadquestionnaire.controls['city'].value=='Other' && (city_others=='' ||city_others==undefined)) || (leadquestionnaire.valid && leadStatusUpdateForm.controls['lead_status'].value=='qualified' && (leadName==''))">Update</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/csagentdashboard/csagentdashboard.component.html